import { render, staticRenderFns } from "./DateAction.vue?vue&type=template&id=1a184f4d"
import script from "./DateAction.vue?vue&type=script&lang=ts"
export * from "./DateAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports